import React, { Component } from 'react';
import ReactTable from 'react-table';
import reqwest from 'reqwest';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelopeOpenText, faPlus } from '@fortawesome/pro-solid-svg-icons';

import history from '../../history';
import settings from '../../../settings';
import Loader from '../../components/Loader';
import Searchbar from '../../components/Searchbar';
import Button from '../../components/Button';
import getConstants from '../../logic/constants';

class Usermanagement extends Component {
  constructor(props) {
    super(props);

    let searchString = '';
    if (props.match.params.search) {
      searchString = props.match.params.search;
    }

    this.state = {
      loading: true,
      positions: [],
      data: [],
      searchString,
    };
  }

  componentDidMount() {
    const promise = reqwest({
      method: 'get',
      url: settings.usermanagement.general.getList,
      data: {
        Token: localStorage.getItem('token'),
      },
    }).then(res => {
      this.setState({
        data: JSON.parse(res).userList,
      });
    });

    const positionPromise = getConstants('Positiontype').then(positions => {
      this.setState({
        positions,
      });
    });

    Promise.all([promise, positionPromise]).then(() => {
      this.setState({
        loading: false,
      });
    });
  }

  _search = value => {
    const val = value.toLowerCase();

    history.replace(val ? `/usermanagement/search/${val}` : '/usermanagement');

    this.setState({
      searchString: val,
    });
  };

  render() {
    if (this.state.loading) {
      return <Loader />;
    }

    const data = this.state.data.filter(rowData =>
      [rowData.Lastname, rowData.Firstname, rowData.Expnr, rowData.Email, rowData.OStreet, rowData.OZip, rowData.OCity]
        .map(e => e.toLowerCase())
        .some(v => {
          return v.indexOf(this.state.searchString) >= 0;
        }),
    );

    return (
      <>
        <div className='Toolbar'>
          <Searchbar placeholder='Benutzer suchen...' defaultValue={this.state.searchString} onChange={this._search} />
          <div className='Toolbar-buttons'>
            <Button icon={faPlus} to='/usermanagement/new'>
              Benutzer erstellen
            </Button>
          </div>
        </div>
        <ReactTable
          getTrProps={(_, { original }) => ({
            onClick: () => this.props.history.push(`/usermanagement/${original.Guid}`),
          })}
          data={data}
          pageSize={data.length}
          noDataText='Es wurden keine Benutzer gefunden.'
          columns={[
            {
              id: 'firstname',
              Header: 'Vorname',
              accessor: 'Firstname',
            },
            {
              id: 'lastname',
              Header: 'Nachname',
              accessor: 'Lastname',
            },
            {
              id: 'address',
              Header: 'Mailadresse',
              Cell: ({ original }) => (
                <>
                  <FontAwesomeIcon fixedWidth icon={faEnvelopeOpenText} /> {original.Email}
                </>
              ),
            },
            {
              id: 'position',
              Header: 'Position',
              Cell: ({ original }) => {
                const position = this.state.positions.find(pos => pos.value === original.Position);
                return <>{position ? position.label : 'Unbekannt'}</>;
              },
            },
          ]}
        />
      </>
    );
  }
}

export default Usermanagement;
